// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from '../../../components/cms/component/ContentComponentItem.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const TooltipDocument = gql`
    query tooltip($path: String!, $locale: Locale!) {
  tooltip(path: $path, locale: $locale) {
    title
    content {
      ...contentComponentItem
    }
  }
}
    ${ContentComponentItemFragmentDoc}`;

export function useTooltipQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.TooltipQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.TooltipQuery, SchemaTypes.TooltipQueryVariables | undefined>({ query: TooltipDocument, variables: undefined, ...options });
};